import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="about" 
      className="py-24 md:py-32 bg-[#F5F1EC] relative overflow-hidden"
      data-testid="about-section"
    >
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-5">
        <svg viewBox="0 0 100 100" fill="#8B2942" className="w-full h-full">
          <circle cx="80" cy="20" r="60" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#8B2942] uppercase tracking-[0.3em] text-sm">
            {t('about.title')}
          </span>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl text-[#1A1A1D] mt-4">
            {t('about.subtitle')}
          </h2>
          <div className="section-divider mt-8" />
        </div>

        {/* Main Content */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-[#6B6B6B] text-lg md:text-xl leading-relaxed mb-6">
            {t('about.text1')}
          </p>
          <p className="text-[#6B6B6B] text-lg leading-relaxed mb-4">
            {t('about.text2')}
          </p>
          <p className="text-[#6B6B6B] text-lg leading-relaxed">
            {t('about.text3')}
          </p>
        </div>

        {/* Signature */}
        <div className="mt-16 flex items-center justify-center gap-4">
          <div className="w-16 h-[1px] bg-[#8B2942]" />
          <span className="font-['Playfair_Display'] text-[#8B2942] italic text-lg">
            Hotel Villa Roze
          </span>
          <div className="w-16 h-[1px] bg-[#8B2942]" />
        </div>
      </div>
    </section>
  );
};

export default About;
